export const createCalendlyElement = (url: string): string => {
  return `
    <div class="calendly-inline-widget" data-url="${url}" style="width:100%;min-width:320px;height:700px;"></div>
    <script type="text/javascript" src="https://assets.calendly.com/assets/external/widget.js" async></script>
  `;
};
